import { render, staticRenderFns } from "./sop-index.vue?vue&type=template&id=6236a567"
import script from "./sop-index.vue?vue&type=script&lang=js"
export * from "./sop-index.vue?vue&type=script&lang=js"
import style0 from "./sop-index.vue?vue&type=style&index=0&id=6236a567&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports